<template>
  <el-container v-loading="loading">
    <el-header style="display: flex; align-items: center;">
      <h1 style="font-size: 20px; font-weight: 700;">{{ title }}</h1>
    </el-header>
    <el-main>
      <CustomForm ref="CustomForm" :form-model="formModel" :form-items="formItem" :form-rules="formRules" />
    </el-main>
    <el-footer style="display: flex; justify-content: flex-end; align-items: center;">
      <el-button size="small" type="primary" @click="handleConfirm">保存</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import CustomForm from '@/components/CustomForm/index'
import { mapActions } from 'vuex'
export default {
  name: 'MenuForm',
  components: { CustomForm },
  props: {
    category: {
      type: Array,
      required: true,
      default: () => []
    },
    checkCategoryData: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      title: '导航：',
      formModel: {
        id: '',
        name: '',
        icon: '',
        url: '',
        status: '',
        types: []
      }
    }
  },
  computed: {
    formItem() {
      return {
        name: {
          elColSpan: 24,
          component: 'CustomFormText',
          label: '名称',
          maxlength: 5
        },
        types: {
          elColSpan: 24,
          component: 'CustomFormSelect',
          label: '展示分类',
          multiple: true,
          dataField: {
            label: 'name',
            value: 'type'
          },
          data: this.category
        }
      }
    },
    formRules() {
      return {
        name: [
          { required: true, message: '名称不能为空', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['miniappMenuMenuSave']),
    openLoading() {
      this.loading = true
    },
    closeLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    initData(menu) {
      Object.assign(this, this.$options.data.call(this))

      this.openLoading()

      this.title += menu.name
      this.formModel.id = menu.id
      this.formModel.name = menu.name
      this.formModel.icon = menu.icon
      this.formModel.url = menu.url
      this.formModel.types = []
      if (menu.status === 1) {
        this.formModel.types = Object.keys(menu.categoryType).map(item => {
          return Number(item)
        })
      }

      this.$refs.CustomForm.$refs.form.clearValidate()

      this.closeLoading()
    },
    handleConfirm() {
      this.openLoading()
      this.$refs.CustomForm.$refs.form.validate(res => {
        if (res) {
          const param = { ...this.formModel }
          if (param.types && param.types.length) {
            param.status = 1
            param.types = param.types.join(',')
          } else {
            param.status = 0
            param.types = JSON.stringify(this.checkCategoryData['type'])
          }
          this.miniappMenuMenuSave({ params: [param] }).then(res => {
            if (res.code !== 200) {
              this.closeLoading()
              this.$message.error(res.msg)
              return
            }
            this.$message.success('修改成功')
            this.$emit('submit', param)
            this.closeLoading()
          }).catch(() => {
            this.closeLoading()
          })
        } else {
          this.closeLoading()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
